import { render, staticRenderFns } from "./treeBox.vue?vue&type=template&id=4a8fef92&scoped=true&"
import script from "./treeBox.vue?vue&type=script&lang=js&"
export * from "./treeBox.vue?vue&type=script&lang=js&"
import style0 from "./treeBox.vue?vue&type=style&index=0&id=4a8fef92&lang=less&scoped=true&"
import style1 from "./treeBox.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8fef92",
  null
  
)

export default component.exports